import { Answer, QuestionnaireService } from "@/types/questionnaire";
import BaseCard from "./BaseCard";
import { Styling } from "@/types/customer";

interface Properties {
    theme: Answer,
    themeIndex: number,
    questionCount: number,
}

function PreThemeInfo(properties: Properties) {
    const { theme, themeIndex, questionCount } = properties;

    return (
        <>
        <div className="relative flex flex-col w-full gap-5 h-full overflow-hidden">
            <BaseCard>
                <div className="flex mb-4">
                    <h3 className="flex-1" style={ {color: Styling.PrimaryColor() } }>{ theme.title }</h3>
                    <img src={'/assets/images/' + theme.image + '.svg'} alt={theme.title + ' icon'} className="flex-initial w-8 h-8 lg:w-10 lg:h-10 lg:self-center" />
                </div>
                <p className="text-lg mb-4">{ QuestionnaireService.AnswerGetDescription(theme, "Het onderwerp wat je nu gaat behandelen is " + theme.title) }</p>
                <h3 style={ {color: Styling.PrimaryColor() } }>Aantal vragen: { questionCount }</h3>
            </BaseCard>
        </div>
        </>
    )
}

export default PreThemeInfo;